import React from 'react';

// Import helpers
import { NAV_LINKS } from './helpers';
import { filterOperatorLinks } from 'helpers/operators';

// Import styles
import { Nav } from './styles';
import FooterLink from './FooterLink';

const FooterNav = () => {
	const filteredLinks = NAV_LINKS.filter(filterOperatorLinks);

	return (
		<Nav>
			{filteredLinks.map(({ path, translation }) => (
				<FooterLink key={path} path={path} translation={translation} />
			))}
		</Nav>
	);
};

export default FooterNav;
